module.exports = __webpack_public_path__ + "static/media/UN0515242-edited.871026a0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/UN0515242-edited.jpg
// module id = 1088
// module chunks = 0